<template>
    <footer class="flex w-full justify-center border-t-1 p-3 sm:p-5">
        <!-- logo AHMP -->
        <nuxt-link
            to="https://www.ahmp.cz/"
            target="_blank"
            class="text-blue-500 hover:underline"
        >
            <img
                src="/img/logo/logo_ahmp.svg"
                alt="logo_ahmp"
                class="mr-3 h-[40px] w-auto sm:mr-5 sm:h-[50px]"
            />
        </nuxt-link>

        <!-- logo IPR -->
        <nuxt-link
            to="https://iprpraha.cz/o-nas"
            target="_blank"
            class="text-blue-500 hover:underline"
        >
            <img
                src="/img/logo/logo_ipr.svg"
                alt="logo_ipr"
                class="mr-3 h-[40px] w-auto sm:mr-5 sm:h-[50px]"
            />
        </nuxt-link>

        <!-- logo Praha -->
        <nuxt-link
            to="https://praha.eu/web/praha/"
            target="_blank"
            class="text-blue-500 hover:underline"
        >
            <img
                src="/img/logo/logo_praha.gif"
                alt="logo_praha"
                class="h-[40px] w-auto sm:h-[50px]"
            />
        </nuxt-link>
    </footer>
</template>

<script setup lang="ts"></script>

<style scoped></style>
